import { render } from "./MaternityManagement.vue?vue&type=template&id=6e7acb97&scoped=true"
import script from "./MaternityManagement.vue?vue&type=script&lang=js"
export * from "./MaternityManagement.vue?vue&type=script&lang=js"

import "./MaternityManagement.vue?vue&type=style&index=0&id=6e7acb97&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7acb97"]])

export default __exports__